import React from "react";
import { Form, Input, Button, Typography, Radio, notification, DatePicker } from "antd";
import useWebinarForm from "../../hooks/useWebinarForm";

const { Title, Text } = Typography;

const WebinarForm = ({ isWebinar = false }) => {
    const { handleSubmit, contextHolder, loading } = useWebinarForm();
    const [form] = Form.useForm();

    return (
        <div className="px-5 py-8 bg-white md:w-[577px] text-gray-900 rounded-xl md:rounded-3xl flex flex-col gap-4 shadow-2xl"
        >
            {contextHolder}
            <p className="text-2xl text-center text-slate-800" >Join the Webinar and Level Up!</p>
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{
                    name: "",
                    email: "",
                    phoneNumber: "",
                    courseOfInterest: ""
                }}
            >
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: "Name is required" }]}
                >
                    <Input placeholder="Enter your name" size="large" />
                </Form.Item>

                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        { required: true, message: "Email is required" },
                        { type: "email", message: "Invalid email address" },
                    ]}
                >
                    <Input placeholder="Enter your email" size="large" />
                </Form.Item>
                <Form.Item
                    label="Phone Number"
                    name="phoneNumber"
                    rules={[
                        { required: true, message: "Phone number is required" },
                        {
                            pattern: /^\+?[1-9]\d{1,14}$/,
                            message: "Enter a valid phone number (e.g., +1234567890)",
                        },
                    ]}
                >
                    <Input placeholder="Enter your phone number with country code" size="large" />
                </Form.Item>


                <Form.Item
                    label="Your Course of Interest"
                    name="courseOfInterest"
                    rules={[{ required: true, message: "Please select Course of Interest" }]}
                >
                    <Radio.Group>
                        <Radio value="frontendEngineering" defaultChecked >Frontend Engineering</Radio>
                        {/* <Radio value="College Student - Final year">College Student - Final year</Radio>
                        <Radio value="College Student - 1st year to pre-final year">
                            College Student - 1st year to pre-final year
                        </Radio>
                        <Radio value="Others">Others</Radio> */}
                    </Radio.Group>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" size="large" className="w-full !bg-blue-900 hover:!bg-blue-700" loading={loading}>
                        Join Now
                    </Button>
                </Form.Item>

                <Text className="text-sm text-gray-600 mt-3">
                    I authorize Pronttera Labs to contact me with course updates & offers via
                    Email/SMS/Whatsapp/Call. I have read and agree to Privacy Policy & Terms of use.
                </Text>
            </Form>
        </div>
    );
};

export default WebinarForm;
